export default function typesAttendance() {
  return {
    1: "entrada",
    2: "salida-comer",
    3: "termino-comida",
    4: "salida",
  } as const;
}
